import { SupportPageContentContainer, SupportRecommendedArticlesContainer } from "@platform/features/support";

export function DashboardSupportHomePage() {
  return (
    <SupportPageContentContainer
      description="Browse our categories or use the search to find help on specific topics."
    >
      <SupportRecommendedArticlesContainer />
    </SupportPageContentContainer>
  );
}

export default DashboardSupportHomePage;


